/* 4Women — Cuando LLEGA el pedido en Santiago si se compra AHORA.
 *
 * El calculo del dia; el elemento y su primer pintado los hace
 * `snippets/fw-llegada.liquid`, que documenta la regla completa.
 *
 * VIVE EN UN ASSET Y NO INLINE desde el 09/09/2026. El snippet se renderiza
 * dentro de una frase —"Te llega {aqui} en Santiago"— y el <script> viajaba con
 * el, o sea metido dentro de un <b> dentro de un <li>. Funcionaba, pero cada
 * superficie que usa el snippet embarcaba otra copia de ~3KB del mismo codigo:
 * hoy el carrito y el menu movil, mañana la ficha. Con el guard de window solo
 * se ejecutaba una vez, pero los bytes se enviaban igual.
 */
(function () {
if (window.__fwLlegada) return;
window.__fwLlegada = true;

var NOMBRES = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

/* La hora de Santiago, no la del visitante: el plazo es el de la bodega.
   Intl con timeZone resuelve el horario de verano solo, que a mano son dos
   cambios al año y un bug asegurado. */
function ahoraSantiago() {
  try {
    var f = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Santiago',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: 'numeric', hour12: false
    });
    var p = {};
    f.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    var h = parseInt(p.hour, 10);
    if (h === 24) h = 0; /* algunos motores devuelven 24 en vez de 0 */
    /* Fecha en UTC a mediodia: solo se usa para contar dias y nombrar el dia
       de la semana, asi que el huso ya no importa y mediodia evita que un
       corrimiento de horas cambie la fecha. */
    var d = new Date(Date.UTC(+p.year, +p.month - 1, +p.day, 12));
    return { fecha: d, hora: h };
  } catch (e) {
    return null;
  }
}

function esHabil(d) {
  var w = d.getUTCDay();
  return w !== 0 && w !== 6;
}

function sumaHabil(d) {
  var x = new Date(d.getTime());
  do { x.setUTCDate(x.getUTCDate() + 1); } while (!esHabil(x));
  return x;
}

function mismoDia(a, b) {
  return a.getUTCFullYear() === b.getUTCFullYear() &&
         a.getUTCMonth() === b.getUTCMonth() &&
         a.getUTCDate() === b.getUTCDate();
}

function calcula(corte) {
  var t = ahoraSantiago();
  if (!t) return null;

  /* Same day si hoy es habil y aun no dan las 11; si no, el siguiente
     habil. Sin dia de transito. */
  var lleg = new Date(t.fecha.getTime());
  if (!esHabil(lleg) || t.hora >= corte) lleg = sumaHabil(lleg);

  if (mismoDia(lleg, t.fecha)) return 'hoy';

  var manana = new Date(t.fecha.getTime());
  manana.setUTCDate(manana.getUTCDate() + 1);
  if (mismoDia(lleg, manana)) return 'mañana';

  return 'el ' + NOMBRES[lleg.getUTCDay()];
}

function pinta() {
  document.querySelectorAll('fw-llegada').forEach(function (el) {
    var corte = parseInt(el.dataset.corte, 10);
    if (isNaN(corte)) return;
    var cuando = calcula(corte);
    if (!cuando) return;
    var destino = el.querySelector('[data-cuando]');
    if (destino && destino.textContent.trim() !== cuando) destino.textContent = cuando;
  });
}

pinta();
/* El carrito se vuelve a pintar entero en cada cambio, asi que el elemento
   que habia se reemplaza por uno nuevo con el texto del servidor: hay que
   recalcular. Y una pestaña abierta cruzando las 11:00 tambien tiene que
   actualizarse sola. Cada 5 min alcanza: el corte es frontera de hora, no
   de minuto. */
document.addEventListener('cart:updated', pinta);
document.addEventListener('cart:update', pinta);
document.addEventListener('visibilitychange', function () { if (!document.hidden) pinta(); });
setInterval(pinta, 300000);
  })();
